import { getUser } from 'stores/user-store';
import { getCompany } from 'stores/company-store';

type SupportedChatLocale = 'en' | 'fr';
type SupportedChatRegion = 'CA' | 'US';

const localeMapToChatLocale = {
  en_US: { language: 'en', country: 'US' },
  en_CA: { language: 'en', country: 'CA' },
  fr_CA: { language: 'fr', country: 'CA' },
};

/**
 *
 * @returns an object with the first and second locale part the users local if present otherwise the company locale
 */
export const getChatLocale = (): {
  firstLocalePart: SupportedChatLocale;
  secondLocalePart: SupportedChatRegion;
} => {
  const userLocale = getUser()['locale'];
  const companyLocale = getCompany()['locale'];
  const companyCountryCode = companyLocale?.split('_')[1] || '';

  let localeToUse = '';
  if (userLocale) {
    const userLocaleLanguage = userLocale.split('_')[0] || '';
    const userLocaleCountry = userLocale.split('_')[1] || '';

    if (userLocaleCountry === companyCountryCode) {
      if (localeMapToChatLocale[userLocale]) {
        localeToUse = userLocale;
      } else {
        localeToUse = companyLocale;
      }
    } else {
      // here we will try to use the user selected language if it is supported
      // ex. for country with locale en_CA and user selected language fr_FR will try to use fr_CA as locale - supported
      // ex. for country with locale en_CA and user selected language it_IT will try to use it_CA as locale - not supported, will use company locale
      const tempLocale = `${userLocaleLanguage}_${companyCountryCode}`;
      if (localeMapToChatLocale[tempLocale]) {
        localeToUse = tempLocale;
      } else {
        localeToUse = companyLocale;
      }
    }
  } else {
    localeToUse = companyLocale;
  }

  const chatLocaleObj =
    localeMapToChatLocale[localeToUse] || localeMapToChatLocale['en_CA'];

  return {
    firstLocalePart: chatLocaleObj.language,
    secondLocalePart: chatLocaleObj.country,
  };
};

export const localeIsSupportedByChat = (locale: string): boolean => {
  const localeLanguage = locale.split('_')[0] || '';
  const localeCountry = locale.split('_')[1] || '';

  const companyLocale = getCompany()['locale'];
  const companyCountryCode = companyLocale?.split('_')[1] || '';

  if (localeCountry === companyCountryCode) {
    if (localeMapToChatLocale[locale]) {
      return true;
    } else {
      return false;
    }
  } else {
    // here we will try to use the user selected language if it is supported
    // ex. for country with locale en_CA and user selected language fr_FR will try to use fr_CA as locale - supported
    // ex. for country with locale en_CA and user selected language it_IT will try to use it_CA as locale - not supported
    const tempLocale = `${localeLanguage}_${companyCountryCode}`;
    if (localeMapToChatLocale[tempLocale]) {
      return true;
    } else {
      return false;
    }
  }
};
